export const statementDescriptorRequiredMessage = 'Informe a descrição na fatura.'

export function validateStatementDescriptor(value: string): string | undefined {
  return value.trim().length === 0 ? statementDescriptorRequiredMessage : undefined
}
